import { App, Button, Dropdown, Popconfirm, Popover, Space, Tag } from 'antd';
import { MdDelete, MdModeEditOutline } from 'react-icons/md';
import Heading from '../../components/common/Heading/Heading';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../../services/react-query/queryKeys';
import { deleteCostCenter, getCostCenters } from '../../network/costCenter';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { ModalAppCostCenter } from '../../components/upeosoft/ModalApp/ModalApp';
import { render } from '@testing-library/react';
import { PiDotsThreeVerticalBold } from 'react-icons/pi';
import DashboardCards from '../Dashboard/DashboardCards';

const CostCenter = ({ t }) => {
  const client = useQueryClient();
  const [openModal, setOpenModal] = useState(false);
  const [idEdit, setIdEdit] = useState(null);
  const [edit, setEdit] = useState(false);
  const navigate = useNavigate();
  const { message } = App.useApp();
  const [searchText, setSearchText] = useState('');
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getCostCenters],
    queryFn: () => getCostCenters(),
    keepPreviousData: true,
  });
  const handleRemove = useMutation({
    mutationFn: (id) => deleteCostCenter(id),
    onSuccess: (data) => {
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message?.message);
      client.invalidateQueries({
        queryKey: [queryKeys.getCostCenters],
      });
    },
    onError: () => {
      message.error('Something went wrong!');
    },
  });
  const items = (record) => [
    {
      key: '1',
      label: t.edit + ' ' + t.paymentEntry,
      icon: <MdModeEditOutline />,
      onClick: () => {
        setIdEdit(record.name);
        setOpenModal(true);
        setEdit(true);
      },
    },
    {
      type: 'divider',
    },
    {
      key: '8',
      label: (
        <Popconfirm
          title={t.DeletetheCostCenter}
          description={t.areYouSure}
          onConfirm={() => handleRemove.mutate(record.name)}
          // onCancel={cancel}
          okText={t.yes}
          cancelText={t.no}
        >
          <span style={{ color: 'red' }}>
            {t.Delete} {t.paymentEntry}
          </span>
        </Popconfirm>
      ),
      icon: <DeleteOutlined style={{ color: 'red' }} />,
    },
  ];
  const columns = [
    {
      title: t.CostCenterName,
      dataIndex: 'cost_center_name',
      filteredValue: [searchText],
      onFilter: (value, record) => {
        const name = String(record.cost_center_name).toLowerCase();
        const searchValue = value.toLowerCase();
        // console.log(record);
        return name.includes(searchValue);
      },
    },
    {
      title: t.ParentCostCenter,
      dataIndex: 'parent_cost_center',
    },
    {
      title: t.cost_center_number,
      dataIndex: 'cost_center_number',
    },
    {
      title: t.isgroup,
      dataIndex: 'is_group',
      render: (text, record) => {
        return text ? <Tag color="green">Yes</Tag> : <Tag color="red">No</Tag>;
      },
    },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      width: 100,
      render: (text, record) => {
        // console.log('record:', record);
        return (
          <Space>
            {/* <Popover
              placement="top"
              title={t.edit}
              onClick={() => {
                setIdEdit(record.name);
                setOpenModal(true);
                setEdit(true);
              }}
            >
              <Button size="small" type="primary">
                <MdModeEditOutline />
              </Button>
            </Popover>
            <Popconfirm
              title={t.DeletetheCostCenter}
              description={t.areYouSure}
              onConfirm={() => handleRemove.mutate(record.name)}
              // onCancel={cancel}
              okText={t.yes}
              cancelText={t.no}
            >
              <Button size="small" type="primary" danger>
                <MdDelete />
              </Button>
            </Popconfirm> */}
            <Dropdown
              menu={{ items: items(record) }}
              overlayClassName="custom-dropdown"
              trigger={['click']}
            >
              <Button
                type="text"
                icon={<PiDotsThreeVerticalBold size={20} color="#86888C" />}
              />
            </Dropdown>
          </Space>
        );
      },
    },
  ];
  const dataTable = data?.data?.map((item, index) => {
    return {
      ...item,
      key: index,
    };
  });
  return (
    <div className="payment-entry">
      {/* <Heading title={t.dashboard} subTitle={t.paymentEntry} path="/" /> */}
      <DashboardCards t={t} />
      <div className="mt-5">
        <DynamicTableAnt
          Placeholder={t.Search + ' ' + t.CostCenterName}
          columns={columns}
          data={dataTable}
          loading={isLoading}
          setSearchText={setSearchText}
          buttonModal={
            <Button
              type="primary"
              onClick={() => {
                setOpenModal(true);
                setEdit(false);
              }}
            >
              <PlusOutlined size={10} /> {t.addCostCenter}
            </Button>
          }
        />
      </div>
      <ModalAppCostCenter
        open={openModal}
        setOpen={setOpenModal}
        setEditId={setIdEdit}
        setEdit={setEdit}
        editId={idEdit}
        edit={edit}
        t={t}
      />
    </div>
  );
};

export default CostCenter;
